import Styled from 'styled-components';

export const NoSidebarPickerWrapper = Styled.div`
  .rdrDefinedRangesWrapper {
    display: none ;
  }
`;
